/**
 * Personal + disposable email domains blocked on Join / Contact / Demo.
 * Keep in sync with mottruck_backend/utility/services/blockedEmailDomains.js
 */
const BLOCKED_EMAIL_DOMAINS = new Set(
  [
    "gmail.com",
    "googlemail.com",
    "outlook.com",
    "hotmail.com",
    "live.com",
    "msn.com",
    "outlook.fr",
    "outlook.de",
    "outlook.co.uk",
    "outlook.es",
    "outlook.it",
    "outlook.pt",
    "hotmail.fr",
    "hotmail.co.uk",
    "hotmail.es",
    "live.fr",
    "live.co.uk",
    "yahoo.com",
    "yahoo.fr",
    "yahoo.co.uk",
    "yahoo.de",
    "yahoo.es",
    "yahoo.it",
    "yahoo.ca",
    "yahoo.com.au",
    "yahoo.co.in",
    "yahoo.com.br",
    "yahoo.com.mx",
    "ymail.com",
    "rocketmail.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "aol.com",
    "aol.co.uk",
    "aim.com",
    "proton.me",
    "protonmail.com",
    "protonmail.ch",
    "pm.me",
    "tuta.com",
    "tuta.io",
    "tutanota.com",
    "tutanota.de",
    "tutamail.com",
    "fastmail.com",
    "fastmail.fm",
    "hey.com",
    "hushmail.com",
    "mailfence.com",
    "duck.com",
    "gmx.com",
    "gmx.net",
    "gmx.de",
    "gmx.at",
    "gmx.ch",
    "web.de",
    "t-online.de",
    "freenet.de",
    "arcor.de",
    "free.fr",
    "laposte.net",
    "orange.fr",
    "wanadoo.fr",
    "sfr.fr",
    "neuf.fr",
    "voila.fr",
    "libero.it",
    "virgilio.it",
    "tin.it",
    "alice.it",
    "sapo.pt",
    "wp.pl",
    "onet.pl",
    "interia.pl",
    "o2.pl",
    "seznam.cz",
    "centrum.cz",
    "mail.ru",
    "internet.ru",
    "list.ru",
    "bk.ru",
    "inbox.ru",
    "yandex.com",
    "yandex.ru",
    "ya.ru",
    "qq.com",
    "foxmail.com",
    "163.com",
    "126.com",
    "sina.com",
    "sina.cn",
    "sohu.com",
    "naver.com",
    "daum.net",
    "hanmail.net",
    "nate.com",
    "rediffmail.com",
    "rediff.com",
    "mail.com",
    "email.com",
    "usa.com",
    "post.com",
    "zohomail.com",
    "zoho.com",
    "zoho.in",
    "10minutemail.com",
    "10minutemail.net",
    "10minutemail.org",
    "guerrillamail.com",
    "guerrillamail.net",
    "guerrillamail.org",
    "guerrillamail.de",
    "sharklasers.com",
    "grr.la",
    "mailinator.com",
    "mailinator.net",
    "mailinator.org",
    "yopmail.com",
    "yopmail.fr",
    "yopmail.net",
    "yopmail.org",
    "yopmail.gq",
    "tempmail.com",
    "temp-mail.org",
    "temp-mail.io",
    "tempail.com",
    "throwawaymail.com",
    "getnada.com",
    "nada.email",
    "emailondeck.com",
    "dispostable.com",
    "maildrop.cc",
    "mohmal.com",
    "burnermail.io",
    "mailnesia.com",
    "mintemail.com",
    "mytemp.email",
    "fakeinbox.com",
    "trashmail.com",
    "trashmail.net",
    "trashmail.org",
    "discard.email",
    "discardmail.com",
    "mailcatch.com",
    "harakirimail.com",
    "crazymailing.com",
    "33mail.com",
    "inboxkitten.com",
    "emailfake.com",
    "tempinbox.com",
    "tempr.email",
    "spambog.com",
    "spambog.de",
    "spambog.ru",
    "mail7.io",
  ].map((d) => d.toLowerCase())
);

export const PROFESSIONAL_EMAIL_MSG =
  "Please use a professional company email address.";

export function extractEmailDomain(email) {
  if (email == null) return "";
  const raw = String(email).trim().toLowerCase();
  const at = raw.lastIndexOf("@");
  if (at < 0 || at === raw.length - 1) return "";
  return raw.slice(at + 1);
}

export function isBlockedEmailDomain(email) {
  const domain = extractEmailDomain(email);
  if (!domain) return false;
  if (BLOCKED_EMAIL_DOMAINS.has(domain)) return true;
  for (const blocked of BLOCKED_EMAIL_DOMAINS) {
    if (domain.endsWith(`.${blocked}`)) return true;
  }
  return false;
}
